export default __webpack_public_path__ + "static/media/odin.cade7baf.svg";